/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingTransactionBill from './accounting-transaction-bill';
import AccountingTransactionBillDetail from './accounting-transaction-bill-detail';
import AccountingTransactionBillUpdate from './accounting-transaction-bill-update';
import AccountingTransactionBillDeleteDialog from './accounting-transaction-bill-delete-dialog';

const AccountingTransactionBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingTransactionBill />} />
    <Route path="new" element={<AccountingTransactionBillUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingTransactionBillDetail />} />
      <Route path="edit" element={<AccountingTransactionBillUpdate />} />
      <Route path="delete" element={<AccountingTransactionBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingTransactionBillRoutes;
